/**
 * `/v1/securities/:ticker/ohlc` in local mode — envelope over generateSeries.
 */
import type { OhlcSeries, SeriesQuery } from '@meridian/contracts';

import { generateSeries } from '../../series/generate-series';
import { syntheticOhlcFromCloses, toOhlcSeries } from '../../series/synthetic-ohlc';
import { syntheticSessions } from '../../series/synthetic-sessions';

import type { SeriesCache } from '../../series/series-cache';
import type { DerivedSecurity } from '../../universe/derive-security';

export function buildOhlcSeries(
  security: DerivedSecurity,
  cache: SeriesCache,
  query: SeriesQuery,
): OhlcSeries {
  const closes = generateSeries(security, query.window, cache);
  return toOhlcSeries(
    security.ticker,
    query.window,
    syntheticSessions(closes.length),
    syntheticOhlcFromCloses(closes),
  );
}
